import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { IconTitleDescComponent } from 'src/app/shared/components/icon-title-desc/icon-title-desc.component';

@Component({
  selector: 'app-hero',
  imports: [IconTitleDescComponent, NgOptimizedImage],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  mottos = [
    {
      imageLink: 'assets/images/exchange_rate.png',
      title: 'Great Rates',
      description: 'Customer satisfaction is our top priority. We work hard to provide our clients with excellent pricing.',
    },
    {
      imageLink: 'assets/images/reduce.png',
      title: 'Reduced Charges',
      description: 'Keeping our administration fees to a minimum ensures that you can exchange with peace of mind.',
    },
    {
      imageLink: 'assets/images/hidden_fees.png',
      title: 'No Hidden Fees!',
      description: `We strive to maintain transparency in our transactions. It's our goal to keep everything clear at the beginning, so you won't run into any surprises at the end!`,
    },
  ];
}
